import clsx from "clsx";
import { ChevronIcon } from "../../icons/chevronIcon";
import { colors } from "../../color";
import { generatePagination } from "../../../lib/types";

interface Props {
    pages: number
    currentPage: number
    setPage: (page: number) => void
}

export function Pagination(props: Props) {
    const { pages } = props
    const { currentPage } = props
    const { setPage } = props

    return (
        <div className="flex h-[40px] p-[8px] gap-[8px] items-center">
            <div
                className="cursor-pointer flex flex-row gap-2 p-2"
                onClick={() => {
                    if (currentPage > 1) {
                        setPage(currentPage - 1)
                    }
                }}
            >
                <ChevronIcon size={20} color={colors.pas[700]} direction="l" />
                <span style={{ color: colors.pas[800] }} className="text-text-sm font-normal">
                    Previous
                </span>
            </div>
            {
                generatePagination(currentPage, pages).map((page, index) => (
                    <div
                        key={'page-' + index}
                        onClick={() => {
                            if (typeof page === "number") {
                                setPage(page)
                            }
                        }}
                        style={{
                            backgroundColor: typeof page === "number" && page === currentPage ? colors.pas[200] : '',
                            color: typeof page === "number" && page === currentPage ? colors.pas[500] : ''
                        }}
                        className={clsx(
                            "w-[36px] text-text-md text-center rounded-lg px-[14px] py-2 flex flex-row gap-2.5 hover:bg-neutral-200",
                            {
                                "text-neutral-700": typeof page === "number" && page !== currentPage,
                                "cursor-pointer": typeof page !== "string"
                            }
                        )}
                    >
                        {page}
                    </div>
                ))}
            <div
                className="cursor-pointer flex flex-row gap-2 p-2"
                onClick={() => {
                    if (currentPage < pages) {
                        setPage(currentPage + 1)
                    }
                }}
            >
                <span style={{ color: colors.pas[800] }} className="text-text-sm font-normal">
                    Next
                </span>
                <ChevronIcon size={20} color={colors.pas[700]} direction="r" />
            </div>
        </div>
    )
}
